import moment from "moment";

export const minDate = (value = () => new Date()) => {
  // const min = new Date(value).toISOString().split('T')[0];
  const min = moment(new Date(value))?.format('YYYY-MM-DD')
  return min;
}